import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

const LoanAccountDetailsSkeleton: React.FC = () => {
    return (
        <>
            <dt className="loan-account-details__term">
                <DarkSkeleton width={70} height={16} />
            </dt>
            <dd className="loan-account-details__description">
                <DarkSkeleton width={40} height={16} />
            </dd>
        </>
    );
};

export default LoanAccountDetailsSkeleton;
